import { NavLink } from "@mantine/core";

import classNames from "./NavLink.module.css";

export const navLinkComponentSettings = NavLink.extend({
  classNames,
});
